import * as React from "react";
import styled from "styled-components";
import { withRouter } from "react-router";
import { RouteComponentProps, Link } from "react-router-dom";
import { Settings, LogOut, File, Grid } from "react-feather";
import { useUserback } from "../../providers/UserbackProvider";
import { Button } from "../ui/Button";

interface IHeaderProps extends RouteComponentProps<{}> {
  logout: () => {};
  handleGraphClick: () => {};
}

var addPadding = {
  padding: "5px",
};

var linkPadding = {
  padding: "0",
};

const Header: React.FC<IHeaderProps> = (props) => {
  const { openFeedback, isLoaded, closeWidget } = useUserback();

  const handleFeedbackClick = () => {
    openFeedback();
  };

  const handleLogout = () => {
    closeWidget();
    props.logout();
  };

  return (
    <>
      <Container>
        <Link style={linkPadding} title="Home" to="/">
          <img
            width="100%"
            style={{
              height: "48px",
              width: "113px",
              maxWidth: "113px",
              padding: "0",
            }}
            src="/assets/logo-white.png"
          />
        </Link>

        <a style={addPadding} title="Graph" onClick={props.handleGraphClick}>
          <Grid />
        </a>

        <Link style={addPadding} title="Settings" to="/settings">
          <Settings />
        </Link>

        <Button
          style={addPadding}
          title={isLoaded ? "Feedback" : "Loading feedback..."}
          onClick={handleFeedbackClick}
          disabled={!isLoaded}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM7 9H17V11H7V9ZM7 12H13V14H7V12ZM7 6H17V8H7V6Z"
              fill="white"
            />
          </svg>
        </Button>

        <a style={addPadding} title="Logout" onClick={handleLogout}>
          <LogOut />
        </a>
      </Container>
    </>
  );
};

const Container = styled.header`
  background-color: ${(props) => props.theme.pallet.primary};
  box-shadow: ${(props) => props.theme.ui.boxShadow};
  padding: 4px 15px 4px 15px;
  margin-bottom: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  a:not(.header-ignore) {
    color: #fff;
    text-decoration: none;
    align-items: center;
    cursor: pointer;
  }
`;

export default withRouter(Header);
